(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-consent"] && !Shopify.designMode) return;
  try {
    class CookieConsent {
    constructor() {
      this.STORAGE_KEY = 'next72-cookie-consent';
      this.EXPIRY_DAYS = 365;
      this.banner = document.getElementById('cookie-consent-banner');
      this.acceptBtn = document.getElementById('cookie-accept');
      this.declineBtn = document.getElementById('cookie-decline');

      this.init();
    }

    init() {
      // Check if consent already given
      if (this.hasConsent()) {
        return; // Don't show banner
      }

      // Show banner
      this.showBanner();

      // Add event listeners
      this.acceptBtn?.addEventListener('click', () => this.acceptCookies());
      this.declineBtn?.addEventListener('click', () => this.declineCookies());
    }

    hasConsent() {
      try {
        const consent = localStorage.getItem(this.STORAGE_KEY);
        if (!consent) return false;

        const data = JSON.parse(consent);
        const now = new Date().getTime();

        // Check if consent is still valid (not expired)
        if (data.expires && data.expires > now) {
          return true;
        }

        // Expired, remove old consent
        localStorage.removeItem(this.STORAGE_KEY);
        return false;
      } catch (e) {
        console.error('Cookie consent error:', e);
        return false;
      }
    }

    showBanner() {
      if (this.banner) {
        this.banner.hidden = false;
      }
    }

    hideBanner() {
      if (this.banner) {
        this.banner.hidden = true;
      }
    }

    acceptCookies() {
      this.saveConsent('accepted');
      this.hideBanner();

      // Trigger event for analytics/tracking scripts
      document.dispatchEvent(new CustomEvent('cookiesAccepted'));
    }

    declineCookies() {
      this.saveConsent('declined');
      this.hideBanner();

      // Trigger event for analytics/tracking scripts
      document.dispatchEvent(new CustomEvent('cookiesDeclined'));
    }

    saveConsent(status) {
      try {
        const now = new Date();
        const expiryDate = new Date(now.getTime() + (this.EXPIRY_DAYS * 24 * 60 * 60 * 1000));

        const consentData = {
          status: status,
          timestamp: now.toISOString(),
          expires: expiryDate.getTime()
        };

        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(consentData));

        // Also set a traditional cookie as backup
        document.cookie = `${this.STORAGE_KEY}=${status}; expires=${expiryDate.toUTCString()}; path=/; SameSite=Strict`;
      } catch (e) {
        console.error('Failed to save cookie consent:', e);
      }
    }
  }

  // Initialize when DOM is ready (prevent multiple instances)
  if (!window.cookieConsentInstance) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        window.cookieConsentInstance = new CookieConsent();
      });
    } else {
      window.cookieConsentInstance = new CookieConsent();
    }
  }
  } catch(e) { console.error(e); }
})();

})();
